module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/logos/logo-celsius-c46eb20a4f364951254da4a62fe1db08.svg";